export default "/images/Icon.svg?846153139785496c1ce82842e01703e9";